export default __webpack_public_path__ + "static/media/_DSC0554.d130e8d6.JPG";